export function portableMarkdownNote(note: {
  manualTitle: string | null
  derivedTitle: string
  body: string
  userTags: string[]
}): string {
  const title = note.manualTitle ?? note.derivedTitle
  const tags = note.userTags.length ? `\n\nTags: ${note.userTags.join(', ')}` : ''
  return `# ${title}\n\n${note.body}${tags}\n`
}
